module.exports = __webpack_public_path__ + "static/polarpumpen-web2@2x-min-357a0fa4462a77784cfb7df3c51b55e8.jpg";